export enum SynchronizationEntity {
    Teams = 'Teams',
    Shifts = 'Shifts',
    Activities = 'Activities',
    Machines = 'Machines',
  HarvestActivityReports = 'HarvestActivityReports',
    Programmings = 'Programmings'
}
